<script lang="ts" setup></script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.207"
    height="15"
    viewBox="0 0 15.207 15"
  >
    <g
      id="Greybutton_Konfigurovatproduktzobrazku"
      transform="translate(0.5 0.5)"
    >
      <g
        id="Group_711"
        data-name="Group 711"
        transform="translate(-0.75 -0.75)"
      >
        <g id="Group_874" data-name="Group 874">
          <path
            id="Path_447"
            data-name="Path 447"
            d="M16,5.889l-5.444,5.444L5.111,12.889,6.667,7.444,12.111,2H2V16H16V2L8.611,9.389"
            transform="translate(-1.25 -1.25)"
            fill="none"
            stroke="#161615"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1"
          />
        </g>
      </g>
      <line
        id="Line_61"
        data-name="Line 61"
        x2="3.5"
        y2="3.25"
        transform="translate(4.75 5.75)"
        fill="none"
        stroke="#161615"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
    </g>
  </svg>
</template>
